
import React from 'react';
import { getData } from '@util';
import { Select, Spin } from 'antd';
import { API_POST_BASE_CERT_BATCH_LIST } from '@api';
// 查询全部证件
class BatchCert extends React.PureComponent {
  state = {
    users: [],
    loading: false,
  };

  componentDidMount() {
    this.getList();
  }

  getList = () => {
    const params = {
      api: API_POST_BASE_CERT_BATCH_LIST,
    };
    this.setState({ loading: true, users: [] });
    getData(params)
      .then(res => {
        console.log('res---', res);
        const { data } = res;
        this.setState({
          users: data || [],
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };


  render() {
    const { users, loading } = this.state;
    const { isSingleSelect, renderValue } = this.props;
    return (
      <Select
        mode={!isSingleSelect && 'multiple'}
        tokenSeparators={[' ']}
        optionFilterProp="children"
        allowClear
        notFoundContent={loading ? <Spin size="small" /> : null}
        showSearch
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            this.props.onChange && this.props.onChange(y);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {users.map(item => (
          <Select.Option
            title={item.userName}
            key={item.certCode}
            value={renderValue ? renderValue(item) : `${item.certCode}&&${item.certName}`}>
            {item.certCode}-{item.certName}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default BatchCert;
